import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { Audio } from "@components/PreviewComponents/Audio";
import { Image } from "@components/PreviewComponents/Image";
import { ScrollingText } from "@components/PreviewComponents/ScrollingText";
import { Video } from "@components/PreviewComponents/Video";
import { Website } from "@components/PreviewComponents/Website";
import { YoutubeLive } from "@components/PreviewComponents/YoutubeLive";
import { Text } from "@components/Text";
import { COLOR_BLACK } from "@static/COLORS";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RenderInnerMediaBlock = ({ firstBlockMedia, index }) => {
  return (
    <Container>
      {_.isNil(firstBlockMedia) && (
        <Text color={COLOR_BLACK} fontWeight="500">
          #{index + 1}
        </Text>
      )}
      {!_.isNil(firstBlockMedia) &&
        (() => {
          const mediaType = _.get(firstBlockMedia, ["type"]);
          const attribute = _.get(firstBlockMedia, ["attribute"]);
          const id = _.get(firstBlockMedia, ["id"]);
          switch (mediaType) {
            case "image":
              return <Image key={id} attribute={attribute} />;
            case "video":
              return (
                <Video
                  key={id}
                  attribute={attribute}
                  mute={true}
                  controls={true}
                />
              );
            case "audio":
              return (
                <Audio
                  key={id}
                  attribute={attribute}
                  controls={true}
                  playing={false}
                />
              );
            case "website":
              return <Website key={id} attribute={attribute} />;
            case "youtube-live":
              return (
                <YoutubeLive
                  key={id}
                  attribute={attribute}
                  playing={false}
                  width={"100%"}
                  height={"100%"}
                />
              );
            case "running-text":
              return <ScrollingText key={id} attribute={attribute} />;

            default:
              return null;
          }
        })()}
    </Container>
  );
};
